import { render, staticRenderFns } from "./NewFQCSeleItemAdmin.vue?vue&type=template&id=25ceaadb&scoped=true"
import script from "./NewFQCSeleItemAdmin.vue?vue&type=script&lang=js"
export * from "./NewFQCSeleItemAdmin.vue?vue&type=script&lang=js"
import style0 from "./NewFQCSeleItemAdmin.vue?vue&type=style&index=0&id=25ceaadb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ceaadb",
  null
  
)

export default component.exports